import {
  Badge,
  Box,
  Card,
  CardBody,
  Heading,
  HStack,
  SimpleGrid,
  Text,
  VStack,
} from "@chakra-ui/react";
import { INDUSTRIES, TEMPLATES } from "../templates";
import { IndustryGlyph } from "../Illustrations";

export default function Step2UseCase({ channel, onTemplatePicked }) {
  // Group templates by industry. Filter by channel when one is set —
  // a user who picked "chat" shouldn't see voice-only templates.
  const filtered = channel
    ? TEMPLATES.filter((t) => t.channel === channel)
    : TEMPLATES;

  return (
    <VStack spacing={8} align="stretch">
      <VStack spacing={1} textAlign="center">
        <Heading size="lg">Pick a use case</Heading>
        <Text color="gray.600">
          Start from a template — you'll be able to edit everything on the next steps.
        </Text>
      </VStack>

      {INDUSTRIES.map((ind) => {
        const items = filtered.filter(
          (t) => t.industry.toLowerCase() === ind.label.toLowerCase()
        );
        if (items.length === 0) return null;
        return (
          <Box key={ind.id}>
            <HStack mb={3}>
              <IndustryGlyph industry={ind.label} size={28} />
              <Heading size="sm">{ind.label}</Heading>
            </HStack>
            <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={3}>
              {items.map((tpl) => (
                <Card
                  key={tpl.id}
                  cursor="pointer"
                  borderWidth="2px"
                  borderColor="gray.200"
                  _hover={{ borderColor: "blue.400", shadow: "md" }}
                  onClick={() => onTemplatePicked(tpl)}
                >
                  <CardBody>
                    <HStack spacing={3} align="start">
                      <Box flexShrink={0}>
                        <IndustryGlyph industry={ind.label} size={40} />
                      </Box>
                      <Box flex="1">
                        <HStack mb={1} justify="space-between">
                          <Heading size="sm">{tpl.title}</Heading>
                          <Badge colorScheme={tpl.channel === "voice" ? "purple" : "blue"}>
                            {tpl.channel}
                          </Badge>
                        </HStack>
                        <Text fontSize="sm" color="gray.600">{tpl.subtitle}</Text>
                      </Box>
                    </HStack>
                  </CardBody>
                </Card>
              ))}
            </SimpleGrid>
          </Box>
        );
      })}

      {filtered.length === 0 && (
        <Text textAlign="center" color="gray.500" py={8}>
          No templates for this channel yet. Go back and describe your agent
          in your own words on Smart start.
        </Text>
      )}
    </VStack>
  );
}
